export enum TEST_EQUIPMENT_CONTEXT_ENUM {
  TEST_CREATION = 'test_creation',
  ATHLETE_CREATION = 'athlete_creation',
  EQUIPMENT_PAGE = 'equipment_page',
}
